import firebase from "@/plugins/firebase"

const escapeRef = firebase.firestore().collection("escapes")

export default class EscapeRepository {
  static findByRef(escapeRef) {
    return new Promise(async (resolve, reject) => {
      try {
        // get escape
        let escape = await escapeRef.get()
        if (!escape.exists) { reject(new Error(`escape: ${escapeRef.path} は見つかりませんでした。`)) }
        let escapeData = { id: escape.id, ref: escape.ref, data: escape.data() }
  
        console.log("escapeData: ")
        console.log(escapeData)
        resolve(escapeData)
      } catch(error) {
        reject(error)
      }
    });
  }

  static findAll() {
    return new Promise(async (resolve, reject) => {
      try {
        let escapes = await escapeRef.get()
        if (!escapes.length <= 0) { reject(new Error(`escapesは見つかりませんでした。`)) }
        let escapeData = escapes.docs.flatMap(doc => { return { id: doc.id, ref: doc.ref, data: doc.data() } } )
  
        console.log("escapeData: ")
        console.log(escapeData)
        resolve(escapeData)
      } catch(error) {
        reject(error)
      }
    });

  }
}
